import useScreen from 'hooks/useScreen';

const useBreakpoint = (breakpoint, ssrWidth) => {
  const screen = useScreen({ ssrWidth });
  if (!breakpoint) throw new Error(`Unknown breakpoint: ${screen}`);
  return screen[breakpoint];
};

export default useBreakpoint;
